var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"div-flex",class:{ left: _vm.left, right: _vm.right, init: _vm.init, center: _vm.center, bottom: _vm.bottom, baseline: _vm.baseline, top: _vm.top, br: _vm.br, fill: _vm.fill, column: _vm.column, shrink: _vm.shrink },style:([_vm.margin ? { margin: _vm.margin } : '',
_vm.height ? { height: _vm.height } : '',
_vm.width ? { width: _vm.width } : '',
]),on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }